"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_aria_1 = require("react-aria");
const components_1 = require("../components");
const Css_1 = require("../Css");
/**
 * A helper component for consistently showing error messages across form fields.
 *
 * Not currently exported as part of our public API.
 */
function ErrorMessage(props) {
    const { id, errorMsg, contrast = false, hidden = false, ...others } = props;
    const errorEl = errorMsg ? ((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.red600.sm.df.mtPx(4).if(contrast).red400.$, children: [(0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.fs0.$, children: (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: "error" }) }), (0, jsx_runtime_1.jsx)("span", { id: id, css: Css_1.Css.ml1.mtPx(2).$, ...others, children: errorMsg })] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
    return hidden ? (0, jsx_runtime_1.jsx)(react_aria_1.VisuallyHidden, { children: errorEl }) : errorEl;
}
exports.ErrorMessage = ErrorMessage;
